<div>
    <div class="row" v-show="!loading">
        <div class="col-xl-12">
            <div class="row">
                <div class="col-xl-12">
                    <div class="card-box">
                        <div class="text-danger">
                            {{errorMessage}}
                        </div>
                        <from-date-to-date-pickers  :title="''"
                                                    :fromDate="report.startDate"
                                                    :toDate="report.endDate"
                                                    :elementId="'dashboardReportDateFilter'"
                                                    :dateFormat="'DD/MM/YYYY'"
                                                    :hideClearButton="hideClearButton"
                                                    :initialiseDate="initialiseDatePicker"
                                                    :initialiseDatePickerEndDate="initialiseDatePickerEndDate"
                                                    @fromDateSelected="onFromReportDateSelect"
                                                    @toDateSelected="onToReportDateSelect"></from-date-to-date-pickers>
                        <br>
                        <button class="btn btn-primary mr-2 mb-1" @click="checkReportCollectionVolumeDispensed">
                            Download Collection Volume Dispensed Report
                        </button>
                        <button class="btn btn-primary mr-2" @click="checkReportDeliveryVarianceReport">
                            Download Delivery Variance Report
                        </button>
                        <button class="btn btn-primary mr-2" @click="checkReportExTankDispenseVarianceReport">
                            Download ExTank Dispense Variance Report
                        </button>
                        <button id="btnDownloadOverdueCustomers" class="btn btn-primary mr-2 mb-1" @click="downloadOverdueCustomerPaymentsReport">
                            Download Customers With Overdue Payments Report
                        </button>
                        <button id="btnDownloadPricingReport" class="btn btn-primary mr-2 mb-1" @click="downloadPricingReport">
                            Download Pricing Report
                        </button>
                        <button id="btnDownloadVolumePerDepotReport" class="btn btn-primary mr-2 mb-1" @click="downloadReportVolumePerDepotByDateRange">
                            Download Volume Per Depot Report
                        </button>
<!--                        <button id="btnDownloadVolumeByCustomerDepotShippingAddress" class="btn btn-primary" @click="downloadVolumeByCustomerDepotShippingAddress">-->
<!--                            Download Volume By Customer/Depot/Shipping Address Report-->
<!--                        </button>-->
                        <button id="btnDownloadVolumeByCustomerDepotShippingAddress" class="btn btn-primary" @click="downloadVolumeByCustomerDepotShippingAddress">
                            Download Volume By Customer/Depot/Shipping Address Report
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-box">
                <div class="row pb-3">
                    <div class="col-sm-6">
                        <from-date-to-date-pickers  :title="''"
                                                    :fromDate="selectedStartDate"
                                                    :toDate="selectedEndDate"
                                                    :elementId="'dashboardDateFilter'"
                                                    :dateFormat="'DD/MM/YYYY'"
                                                    :hideClearButton="hideClearButton"
                                                    :initialiseDate="initialiseDatePicker"
                                                    :initialiseDatePickerEndDate="initialiseDatePickerEndDate"
                                                    @clearDatePicker="onDateFilterClearClick"
                                                    @fromDateSelected="onFromDateCreatedSelect"
                                                    @toDateSelected="onToDateCreatedSelect"></from-date-to-date-pickers>
                    </div>
                    <div class="col-md-6">
                        <label >Order Type</label>
                        <bootstrap-select :selectOptions="orderTypes" :selectedOption="selectedOrderType" :elementId="'orderTypeFilterSelect'"
                                          :returnSelectedOptionText="true"
                                          @changeSelect="onOrderTypeFilterSelect"></bootstrap-select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="card-box">
                        <div v-show="productVolumePerDay !== null">
                            <h4 class="header-title mb-3">Product Volume Per Day</h4>
                            <div data-ui-jp="echarts" id="productVolumePerDayChart" style="height:500px"></div>
                        </div>
                        <div v-show="productVolumePerDay === null">
                            <h4 class="header-title mb-3 text-center">
                                No Data Available
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="card-box">
                        <div v-show="totalAmountPerDayChartData !== null">
                            <h4 class="header-title mb-3">Total Amount Spent On Orders Per Product</h4>
                            <div data-ui-jp="echarts" id="productPricePerDay" style="height:500px"></div>
                        </div>
                        <div v-show="totalAmountPerDayChartData === null">
                            <h4 class="header-title mb-3 text-center">
                                No Data Available
                            </h4>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="card-box">
                        <div v-show="customerVolumePerDayData !== null">
                            <h4 class="header-title mb-3">Customer Volume Per Day</h4>
                            <div data-ui-jp="echarts" id="customerVolumePerDayChart" style="height:500px"></div>
                        </div>
                        <div v-show="customerVolumePerDayData === null">
                            <h4 class="header-title mb-3 text-center">
                                No Data Available
                            </h4>
                        </div>

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="card-box">
                        <div v-show="totalVolumePerStatusChartData !== null && totalVolumePerStatusChartData.length > 0">
                            <h4 class="header-title mb-3">Total Volume Per Order Status (Litres)</h4>
                            <div data-ui-jp="echarts" id="totalVolumePerOrderStatus" style="height:500px"></div>
                        </div>
                        <div v-show="totalVolumePerStatusChartData === null || totalVolumePerStatusChartData.length === 0">
                            <h4 class="header-title mb-3 text-center">
                                No Data Available
                            </h4>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card-box">
                        <div v-show="totalAmountPerStatusChartData !== null && totalAmountPerStatusChartData.length > 0">
                            <h4 class="header-title mb-3">Total Sales Per Order Status (Rands)</h4>
                            <div data-ui-jp="echarts" id="totalAmountPerOrderStatus" style="height:500px"></div>
                        </div>
                        <div v-show="totalAmountPerStatusChartData === null || totalAmountPerStatusChartData.length === 0">
                            <h4 class="header-title mb-3 text-center">
                                No Data Available
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <loading-spinner :showSpinner="loading"></loading-spinner>
</div>
